import { ElementRef } from '@angular/core';

export const MOCK_VARIANT_ELEMENT = (id: string, scrollIntoView: () => void): ElementRef => {
  const htmlDivElement = document.createElement('div');
  htmlDivElement.textContent = '';
  htmlDivElement.id = id;
  htmlDivElement.scrollIntoView = scrollIntoView;
  const htmlHeadingElement = document.createElement('h2');
  htmlHeadingElement.classList.add('title');
  htmlDivElement.appendChild(htmlHeadingElement);

  return new ElementRef(htmlDivElement);
};
